// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__yWFaa","alert":"SettungsInbox_alert__2lGn0"};